import React, { useEffect, useRef, useState } from "react";

const BANNER_VIDEO_SRC = "https://api.mbasolutions.co/api/video/home";

/**
 * Full-width brand banner. Intentionally carries no copy — the page heading
 * and introduction live in the section directly beneath it.
 */
const HomeBanner = () => {
  const poster = `${process.env.PUBLIC_URL}/assets/Logo.webp`;
  const [loaded, setLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return undefined;

    const handleLoadedData = () => setLoaded(true);
    videoElement.addEventListener("loadeddata", handleLoadedData);

    return () => {
      videoElement.removeEventListener("loadeddata", handleLoadedData);
    };
  }, []);

  return (
    <section className="relative w-full bg-gray-900" aria-hidden="true">
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={poster}
        tabIndex={-1}
        className={`h-[42vh] w-full object-cover transition-opacity duration-700 sm:h-[55vh] lg:h-[68vh] ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
      >
        <source src={BANNER_VIDEO_SRC} type="video/mp4" />
      </video>
    </section>
  );
};

export default HomeBanner;
